var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-layout",
        [
          _c("v-flex", { staticClass: "headline" }, [
            _vm._v(_vm._s(_vm.$t("generalSettings")))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c(
        "v-form",
        {
          ref: "general",
          attrs: { "lazy-validation": "" },
          model: {
            value: _vm.isGeneralValid,
            callback: function($$v) {
              _vm.isGeneralValid = $$v
            },
            expression: "isGeneralValid"
          }
        },
        [
          _c(
            "v-layout",
            [
              _c(
                "v-flex",
                { attrs: { md4: "", lg3: "" } },
                [
                  _c("v-switch", {
                    attrs: {
                      label: _vm.$t(
                        _vm.generalSettings.isMeasurementMetric
                          ? "metric(kg/cm)"
                          : "imperial(lbs/inch)"
                      )
                    },
                    model: {
                      value: _vm.generalSettings.isMeasurementMetric,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.generalSettings,
                          "isMeasurementMetric",
                          $$v
                        )
                      },
                      expression: "generalSettings.isMeasurementMetric"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md4: "", lg3: "" } },
                [
                  _c("v-switch", {
                    attrs: { label: _vm.$t("scanForm") },
                    model: {
                      value: _vm.generalSettings.isScanForm,
                      callback: function($$v) {
                        _vm.$set(_vm.generalSettings, "isScanForm", $$v)
                      },
                      expression: "generalSettings.isScanForm"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            [
              _c("v-icon", { attrs: { color: "primary" } }, [_vm._v("info")]),
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("metricSystemIsOnlyForInputData")) +
                  "\n    "
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            [
              _c(
                "v-flex",
                { attrs: { md4: "", lg3: "" } },
                [
                  _c("v-switch", {
                    attrs: {
                      label: _vm.$t(
                        _vm.generalSettings.enableAmazonSites
                          ? "amazonSites"
                          : "disabledAmazonSites"
                      )
                    },
                    model: {
                      value: _vm.generalSettings.enableAmazonSites,
                      callback: function($$v) {
                        _vm.$set(_vm.generalSettings, "enableAmazonSites", $$v)
                      },
                      expression: "generalSettings.enableAmazonSites"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        [
          _c("v-flex", { staticClass: "headline" }, [
            _vm._v(_vm._s(_vm.$t("featureSettings")))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c(
        "v-form",
        {
          ref: "feature",
          attrs: { "lazy-validation": "" },
          model: {
            value: _vm.isFeatureValid,
            callback: function($$v) {
              _vm.isFeatureValid = $$v
            },
            expression: "isFeatureValid"
          }
        },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { md4: "" } },
                [
                  _c("v-checkbox", {
                    attrs: { label: _vm.$t("skuMode") },
                    model: {
                      value: _vm.generalSettings.skuMode,
                      callback: function($$v) {
                        _vm.$set(_vm.generalSettings, "skuMode", $$v)
                      },
                      expression: "generalSettings.skuMode"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md4: "" } },
                [
                  _c("v-checkbox", {
                    attrs: { label: _vm.$t("advancedOutboundMode") },
                    model: {
                      value: _vm.generalSettings.advancedOutbound,
                      callback: function($$v) {
                        _vm.$set(_vm.generalSettings, "advancedOutbound", $$v)
                      },
                      expression: "generalSettings.advancedOutbound"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md4: "" } },
                [
                  _c("v-checkbox", {
                    attrs: { label: _vm.$t("prescan") },
                    model: {
                      value: _vm.generalSettings.activatePrescan,
                      callback: function($$v) {
                        _vm.$set(_vm.generalSettings, "activatePrescan", $$v)
                      },
                      expression: "generalSettings.activatePrescan"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { md4: "" } },
                [
                  _c("v-checkbox", {
                    attrs: { label: _vm.$t("enableInboundSNScan") },
                    model: {
                      value: _vm.generalSettings.enableSnScan,
                      callback: function($$v) {
                        _vm.$set(_vm.generalSettings, "enableSnScan", $$v)
                      },
                      expression: "generalSettings.enableSnScan"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md4: "" } },
                [
                  _c("v-checkbox", {
                    attrs: { label: _vm.$t("measureDimension") },
                    model: {
                      value: _vm.generalSettings.measureDimension,
                      callback: function($$v) {
                        _vm.$set(_vm.generalSettings, "measureDimension", $$v)
                      },
                      expression: "generalSettings.measureDimension"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md4: "" } },
                [
                  _c("v-checkbox", {
                    attrs: { label: _vm.$t("scanIMEI") },
                    model: {
                      value: _vm.generalSettings.enableIMEIScan,
                      callback: function($$v) {
                        _vm.$set(_vm.generalSettings, "enableIMEIScan", $$v)
                      },
                      expression: "generalSettings.enableIMEIScan"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md4: "", "mb-2": "" } },
                [
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    "a",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass:
                                            "blue--text text-decoration-underline font-weight-medium mr-2",
                                          attrs: {
                                            href: "https://qz.io/download/",
                                            target: "_blank"
                                          }
                                        },
                                        "a",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("autoPrintTool")) +
                                          "\n                "
                                      ),
                                      _c(
                                        "v-icon",
                                        { attrs: { small: "", color: "blue" } },
                                        [_vm._v("open_in_new")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ])
                        },
                        [
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.$t("autoPrintHelp")))])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tooltip",
                        {
                          staticClass: "ml-4",
                          attrs: { top: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    "a",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass:
                                            "blue--text text-decoration-underline font-weight-medium",
                                          attrs: {
                                            href:
                                              "../../static/qz-certificate.txt",
                                            download: ""
                                          }
                                        },
                                        "a",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("downloadCert")) +
                                          "\n                "
                                      ),
                                      _c(
                                        "v-icon",
                                        { attrs: { small: "", color: "blue" } },
                                        [_vm._v("get_app")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ])
                        },
                        [
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("downloadCertHelp")))
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        [
          _c("v-flex", { staticClass: "headline" }, [
            _vm._v(_vm._s(_vm.$t("forecastSettings")))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c(
        "v-form",
        {
          ref: "forecast",
          attrs: { "lazy-validation": "" },
          model: {
            value: _vm.isForecastValid,
            callback: function($$v) {
              _vm.isForecastValid = $$v
            },
            expression: "isForecastValid"
          }
        },
        [
          _c(
            "v-layout",
            [
              _c(
                "v-flex",
                { attrs: { md3: "" } },
                [
                  _c(
                    "span",
                    { staticStyle: { color: "rgba(0, 0, 0, 0.54)" } },
                    [_vm._v(_vm._s(_vm.$t("standardSmallBox")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { "align-center": "" } },
                    [
                      _c(
                        "v-flex",
                        { staticClass: "mr-3", attrs: { xs4: "" } },
                        [
                          _c("v-text-field", {
                            staticClass: "table-item",
                            attrs: {
                              "hide-details": "",
                              suffix: _vm.sizeSuffix,
                              rules: [
                                _vm.fieldIsRequired("length"),
                                _vm.fieldIsOverZero("length")
                              ]
                            },
                            model: {
                              value:
                                _vm.generalSettings["standardSmallBox"].length,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.generalSettings["standardSmallBox"],
                                  "length",
                                  _vm._n($$v)
                                )
                              },
                              expression:
                                "generalSettings['standardSmallBox'].length"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { staticClass: "mr-3", attrs: { xs4: "" } },
                        [
                          _c("v-text-field", {
                            staticClass: "table-item",
                            attrs: {
                              "hide-details": "",
                              suffix: _vm.sizeSuffix,
                              rules: [
                                _vm.fieldIsRequired("width"),
                                _vm.fieldIsOverZero("width")
                              ]
                            },
                            model: {
                              value:
                                _vm.generalSettings["standardSmallBox"].width,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.generalSettings["standardSmallBox"],
                                  "width",
                                  _vm._n($$v)
                                )
                              },
                              expression:
                                "generalSettings['standardSmallBox'].width"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "" } },
                        [
                          _c("v-text-field", {
                            staticClass: "table-item",
                            attrs: {
                              "hide-details": "",
                              suffix: _vm.sizeSuffix,
                              rules: [
                                _vm.fieldIsRequired("height"),
                                _vm.fieldIsOverZero("height")
                              ]
                            },
                            model: {
                              value:
                                _vm.generalSettings["standardSmallBox"].height,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.generalSettings["standardSmallBox"],
                                  "height",
                                  _vm._n($$v)
                                )
                              },
                              expression:
                                "generalSettings['standardSmallBox'].height"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        [
          _c("v-flex", { staticClass: "headline" }, [
            _vm._v(_vm._s(_vm.$t("defaultSettings")))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c(
        "v-form",
        {
          ref: "default",
          attrs: { "lazy-validation": "" },
          model: {
            value: _vm.isDefaultValid,
            callback: function($$v) {
              _vm.isDefaultValid = $$v
            },
            expression: "isDefaultValid"
          }
        },
        [
          _c(
            "v-layout",
            [
              _c(
                "v-flex",
                { attrs: { md4: "", lg3: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      items: _vm.organizations,
                      "item-text": "organizationId",
                      "item-value": "key",
                      label: _vm.$t("defaultOrganizationId"),
                      clearable: ""
                    },
                    model: {
                      value: _vm.generalSettings.defaultOrgId,
                      callback: function($$v) {
                        _vm.$set(_vm.generalSettings, "defaultOrgId", $$v)
                      },
                      expression: "generalSettings.defaultOrgId"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            [
              _c(
                "v-flex",
                { attrs: { md4: "", lg3: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      items: _vm.warehousesSites,
                      "item-text": "siteName",
                      "item-value": "key",
                      label: _vm.$t("defaultWarehouseSite"),
                      clearable: ""
                    },
                    model: {
                      value: _vm.defaultSite,
                      callback: function($$v) {
                        _vm.defaultSite = $$v
                      },
                      expression: "defaultSite"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            [
              _c(
                "v-flex",
                { attrs: { md4: "", lg3: "" } },
                [
                  _c("v-combobox", {
                    attrs: {
                      items: _vm.deliveryChannelList,
                      "item-text": "displayName",
                      "item-value": "key",
                      label: _vm.$t("verifyLabelTypes"),
                      "return-object": false,
                      required: "",
                      chips: "",
                      multiple: "",
                      clearable: ""
                    },
                    model: {
                      value: _vm.selectedChannels,
                      callback: function($$v) {
                        _vm.selectedChannels = $$v
                      },
                      expression: "selectedChannels"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            [
              _c(
                "v-flex",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function() {
                          _vm.ignoredCheckUpcsInEdit =
                            _vm.generalSettings.ignoredCheckUpcs || []
                          _vm.showPopup = true
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("ignoredCheckUpcs")))]
                  ),
                  _vm._v(" "),
                  _c("FormSubmitPopup", {
                    attrs: {
                      title: _vm.$t("ignoredCheckUpcs"),
                      medium: "",
                      rightMethod: _vm.confirmSelection
                    },
                    on: {
                      popupClose: function() {
                        _vm.showPopup = false
                        _vm.ignoredCheckUpcsInEdit = []
                      }
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "input",
                        fn: function() {
                          return [
                            _c(
                              "v-container",
                              [
                                _c(
                                  "v-toolbar",
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        "append-icon": "filter_list",
                                        label: _vm.$t("filter"),
                                        "single-line": "",
                                        clearable: "",
                                        "hide-details": ""
                                      },
                                      model: {
                                        value: _vm.search,
                                        callback: function($$v) {
                                          _vm.search =
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                        },
                                        expression: "search"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: { bottom: "" },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "activator",
                                            fn: function(ref) {
                                              var on = ref.on
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    {
                                                      attrs: {
                                                        color: "primary"
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.selectAllItems
                                                      }
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("selectAll")
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ])
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("selectAllFilteredItems")
                                            )
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { color: "primary" },
                                        on: { click: _vm.deselectAllItems }
                                      },
                                      [_vm._v(_vm._s(_vm.$t("deselectAll")))]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("v-data-iterator", {
                                  staticClass: "my-4",
                                  attrs: {
                                    items: _vm.filteredUpcs,
                                    "rows-per-page-items": [100, 200, 500],
                                    "items-per-page": _vm.itemsPerPage,
                                    page: _vm.page,
                                    "content-tag": "v-layout",
                                    row: "",
                                    wrap: ""
                                  },
                                  on: {
                                    "update:itemsPerPage": function($event) {
                                      _vm.itemsPerPage = $event
                                    },
                                    "update:items-per-page": function($event) {
                                      _vm.itemsPerPage = $event
                                    },
                                    "update:page": function($event) {
                                      _vm.page = $event
                                    }
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "item",
                                      fn: function(ref) {
                                        var item = ref.item
                                        return [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs6: "" } },
                                            [
                                              _c("v-checkbox", {
                                                staticClass: "mr-2",
                                                attrs: {
                                                  "input-value": _vm.ignoredCheckUpcsInEdit.includes(
                                                    item
                                                  ),
                                                  label: item
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.toggleIgnoredCheckUpcs(
                                                      item
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ])
                                }),
                                _vm._v(" "),
                                _c(
                                  "v-footer",
                                  [
                                    _c(
                                      "v-layout",
                                      { attrs: { "align-center": "" } },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "status-bar" },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(_vm.$t("selected")) +
                                                " "
                                            ),
                                            _c("span", [
                                              _vm._v(_vm._s(_vm.selectedCount))
                                            ]),
                                            _vm._v(" UPC\n                  ")
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("v-spacer"),
                                        _vm._v(" "),
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "activator",
                                                fn: function(ref) {
                                                  var on = ref.on
                                                  return [
                                                    _c(
                                                      "v-btn",
                                                      _vm._g(
                                                        {
                                                          attrs: {
                                                            color: "primary"
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.selectAllItems
                                                          }
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("selectAll")
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ])
                                          },
                                          [
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "selectAllFilteredItems"
                                                  )
                                                )
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: { color: "primary" },
                                            on: { click: _vm.deselectAllItems }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("deselectAll"))
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        },
                        proxy: true
                      }
                    ]),
                    model: {
                      value: _vm.showPopup,
                      callback: function($$v) {
                        _vm.showPopup = $$v
                      },
                      expression: "showPopup"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        [
          _c(
            "v-flex",
            { attrs: { md3: "", lg2: "" } },
            [
              _c(
                "v-btn",
                { attrs: { color: "primary" }, on: { click: _vm.onSubmitted } },
                [_vm._v(_vm._s(_vm.$t("save")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-568287d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-568287d0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WarehouseGeneralSettings.vue
// module id = null
// module chunks = 